import TicketProvider from './TicketContext';
import Ticket from './Ticket';


let Index = () => {
    return (
        <TicketProvider>
            <Ticket />
        </TicketProvider>
    )
}

export default Index;